/* Contact hub v2.5 - tiles, panels with working Back button, one submit path per tile that waits for a real answer. */
(function () {
  'use strict';

  var MAX_FILES = 5;
  var MAX_TOTAL = 12 * 1024 * 1024;

  /* Australian numbers only (same rules as the n8n relay): mobile 04xx, landline 02/03/07/08, 13xxxx, 1300 and 1800.
     Spaces, dashes, dots and brackets are fine, +61 is fine. Returns the digits or null. */
  function auPhone(input) {
    if (input === null || input === undefined) return null;
    var s = String(input).trim();
    if (!s || /[^\d\s+()\-.]/.test(s)) return null;
    s = s.replace(/^\+\s*61\s*\(\s*0\s*\)/, '+61');
    var d = s.replace(/[^\d+]/g, '');
    if (d.indexOf('+') > 0 || d.lastIndexOf('+') > 0) return null;
    if (d.charAt(0) === '+') {
      if (d.indexOf('+61') !== 0) return null;
      d = '0' + d.slice(3);
    } else if (d.indexOf('0061') === 0) {
      d = '0' + d.slice(4);
    } else if (d.indexOf('61') === 0 && d.length === 11) {
      d = '0' + d.slice(2);
    }
    if (/^04\d{8}$/.test(d) || /^0[2378]\d{8}$/.test(d) || /^(13\d{4}|1300\d{6}|1800\d{6})$/.test(d)) return d;
    return null;
  }

  function emailOk(v) {
    var s = String(v || '').trim();
    return s.length <= 120 && /^[^\s@<>()[\]\\,;:"]+@[^\s@<>()[\]\\,;:"]+\.[^\s@<>()[\]\\,;:"]{2,}$/.test(s);
  }

  if (typeof module === 'object' && module && module.exports) module.exports = { auPhone: auPhone, emailOk: emailOk };
  if (typeof document === 'undefined') return;

  var hub = document.querySelector('[data-contact-hub]');
  if (!hub) return;

  var ENV = hub.getAttribute('data-env') === 'live' ? 'live' : 'preview';
  var salesUrl = hub.getAttribute('data-sales-url') || '';
  var supportUrl = hub.getAttribute('data-support-url') || '';
  var tiles = hub.querySelector('[data-ch-tiles]');
  var thanks = hub.querySelector('[data-ch-thanks]');
  var thanksHeading = hub.querySelector('[data-ch-thanks-heading]');
  var thanksText = hub.querySelector('[data-ch-thanks-text]');
  var panels = [].slice.call(hub.querySelectorAll('[data-ch-panel]'));
  var intro = hub.querySelector('[data-ch-intro]');
  var openedAt = {};

  function urlOk(u) { return /^https:\/\/[^\s]+$/.test(u); }

  /* Navigation: each screen is a history entry (no #hash), so the phone Back button returns to the tiles. */
  function paint(kind) {
    var isThanks = kind === 'thanks';
    tiles.hidden = !!kind;
    thanks.hidden = !isThanks;
    if (intro) intro.hidden = !!kind;
    panels.forEach(function (p) { p.hidden = p.getAttribute('data-ch-panel') !== kind; });
  }

  function toTop(target) {
    var el = target || hub;
    var y = el.getBoundingClientRect().top + window.pageYOffset - 130;
    window.scrollTo(0, Math.max(0, y));
  }

  function focusScreen(kind) {
    var el = null;
    if (kind === 'thanks') el = thanks;
    else if (kind) el = hub.querySelector('[data-ch-panel="' + kind + '"] [data-ch-heading]');
    if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  }

  function go(kind, push) {
    paint(kind);
    if (kind && kind !== 'thanks' && !openedAt[kind]) openedAt[kind] = Date.now();
    toTop();
    focusScreen(kind);
    if (push) {
      try { history.pushState({ chPanel: kind || null }, '', location.href); } catch (e) { /* history blocked: Back just leaves the page */ }
    }
  }

  window.addEventListener('popstate', function (e) {
    var kind = e.state && Object.prototype.hasOwnProperty.call(e.state, 'chPanel') ? e.state.chPanel : null;
    paint(kind);
    toTop();
    focusScreen(kind);
  });

  [].forEach.call(hub.querySelectorAll('[data-ch-open]'), function (b) {
    b.addEventListener('click', function () { go(b.getAttribute('data-ch-open'), true); });
  });
  [].forEach.call(hub.querySelectorAll('[data-ch-back]'), function (b) {
    b.addEventListener('click', function () {
      if (thanks.contains(b)) go(null, true);
      else if (history.state && history.state.chPanel) history.back();
      else go(null, false);
    });
  });

  function showThanks(heading, text) {
    if (heading) thanksHeading.textContent = heading;
    if (text) thanksText.textContent = text;
    go('thanks', true);
  }

  /* Products for the support form come from a JSON snippet, not from this file. */
  var catalog = { products: {}, suppliers: [] };
  try {
    var node = document.querySelector('[data-ch-products]');
    if (node) catalog = JSON.parse(node.textContent);
  } catch (e) { /* lists stay empty: the selects still offer Other */ }

  function fillSelect(sel, items, placeholder) {
    sel.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    sel.appendChild(first);
    items.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v;
      o.textContent = v;
      sel.appendChild(o);
    });
  }

  var support = hub.querySelector('[data-ch-form="support"]');
  if (support) {
    var cat = support.querySelector('[data-ch-cat]');
    var model = support.querySelector('[data-ch-model]');
    var sup = support.querySelector('[data-ch-sup]');
    fillSelect(cat, Object.keys(catalog.products || {}).concat(['Other']), 'Please choose');
    fillSelect(model, [], 'Choose the type first');
    fillSelect(sup, (catalog.suppliers || []).concat(['Other']), 'Please choose');
    model.disabled = true;
    cat.addEventListener('change', function () {
      var list = (catalog.products || {})[cat.value] || [];
      fillSelect(model, list.length ? list.concat(['Other / not sure']) : [], list.length ? 'Please choose' : 'Not needed');
      model.disabled = !list.length;
    });
    var groups = [].slice.call(support.querySelectorAll('[data-ch-group]'));
    [].forEach.call(support.querySelectorAll('[name="stype"]'), function (r) {
      r.addEventListener('change', function () {
        groups.forEach(function (g) { g.hidden = g.getAttribute('data-ch-group') !== r.value; });
        /* Accounts enquiries are email only, so there is nowhere to attach files */
        var up = support.querySelector('[data-ch-upload]');
        if (up) up.hidden = r.value === 'accounts';
        clearError(support.querySelector('.ch-choices'));
      });
    });
  }

  /* Form helpers */
  function field(form, k) { return form.querySelector('[data-k="' + k + '"]'); }
  function val(form, k) {
    var els = form.querySelectorAll('[data-k="' + k + '"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (k !== 'trap' && el.closest('[hidden]')) continue;
      if (el.type === 'radio') { if (el.checked) return el.value; continue; }
      return (el.value || '').trim();
    }
    return '';
  }

  function setError(wrap, msg) {
    if (!wrap) return;
    var e = wrap.querySelector('[data-ch-err]');
    var input = wrap.querySelector('input, select, textarea');
    if (e) { e.textContent = msg || ''; e.hidden = !msg; }
    if (input && input.type !== 'radio') { if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
    wrap.classList.toggle('has-error', !!msg);
  }
  function clearError(wrap) { setError(wrap, ''); }

  function validate(form, kind) {
    var bad = [];
    function need(k, msg, test) {
      var el = field(form, k);
      var wrap = el && el.closest('[data-ch-field]');
      var v = val(form, k);
      var ok = test ? test(v) : !!v;
      setError(wrap, ok ? '' : msg);
      if (!ok && el) bad.push(el);
    }
    need('fn', 'Please enter your first name.');
    need('ln', 'Please enter your last name.');
    need('em', 'Please enter a valid email address, like name@example.com.', emailOk);
    need('ph', 'Please enter an Australian phone number, for example 0412 345 678 or 07 3808 0900.', function (v) { return !!auPhone(v); });
    need('msg', 'Please tell us how we can help.');
    if (kind === 'support') {
      var radios = form.querySelectorAll('[name="stype"]');
      var chosen = form.querySelector('[name="stype"]:checked');
      var wrap = form.querySelector('.ch-choices');
      setError(wrap, chosen ? '' : 'Please choose what you need help with.');
      if (!chosen && radios[0]) bad.unshift(radios[0]);
      var fl = fileCheck(form);
      if (fl) bad.push(form.querySelector('[data-ch-files]'));
    }
    if (bad.length) { try { bad[0].focus(); } catch (e) { /* ignore */ } }
    return bad.length === 0;
  }

  function fileCheck(form) {
    var input = form.querySelector('[data-ch-files]');
    if (!input || input.closest('[hidden]')) return '';
    var wrap = input.closest('[data-ch-field]');
    var list = form.querySelector('[data-ch-files-list]');
    var files = [].slice.call(input.files || []);
    var total = files.reduce(function (n, f) { return n + f.size; }, 0);
    var msg = '';
    if (files.length > MAX_FILES) msg = 'Please choose up to ' + MAX_FILES + ' files.';
    else if (total > MAX_TOTAL) msg = 'Those files are ' + (total / 1048576).toFixed(1) + ' MB together. Please keep it under 12 MB, for example by sending fewer photos.';
    setError(wrap, msg);
    if (list) {
      list.classList.toggle('has-files', files.length > 0);
      list.textContent = files.length
        ? files.map(function (f) { return f.name; }).join(', ') + ' (' + (total / 1048576).toFixed(1) + ' MB)'
        : 'A photo of the problem or the label helps us sort it out faster.';
    }
    return msg;
  }

  [].forEach.call(hub.querySelectorAll('[data-ch-files]'), function (i) {
    i.addEventListener('change', function () { fileCheck(i.closest('form')); });
    var zone = i.closest('[data-ch-drop]');
    if (zone) {
      ['dragenter', 'dragover'].forEach(function (t) { zone.addEventListener(t, function () { zone.classList.add('is-drag'); }); });
      ['dragleave', 'drop'].forEach(function (t) { zone.addEventListener(t, function () { zone.classList.remove('is-drag'); }); });
    }
  });
  [].forEach.call(hub.querySelectorAll('[data-ch-field] input, [data-ch-field] textarea'), function (el) {
    el.addEventListener('input', function () {
      var wrap = el.closest('[data-ch-field]');
      if (wrap && wrap.classList.contains('has-error') && el.type !== 'file') clearError(wrap);
    });
  });
  [].forEach.call(hub.querySelectorAll('[data-k="ph"], [data-k="em"]'), function (el) {
    el.addEventListener('blur', function () {
      if (!el.value.trim()) return;
      var good = el.getAttribute('data-k') === 'ph' ? !!auPhone(el.value) : emailOk(el.value);
      setError(el.closest('[data-ch-field]'), good ? '' : (el.getAttribute('data-k') === 'ph' ? 'Please enter an Australian phone number, for example 0412 345 678 or 07 3808 0900.' : 'Please enter a valid email address, like name@example.com.'));
    });
  });

  function formError(form, msg) {
    var box = form.querySelector('[data-ch-error]');
    box.textContent = msg || '';
    box.hidden = !msg;
    if (msg) { box.focus(); box.scrollIntoView({ block: 'center' }); }
  }

  function busy(form, on, text) {
    var btn = form.querySelector('[data-ch-submit]');
    var st = form.querySelector('[data-ch-status]');
    form.setAttribute('data-busy', on ? '1' : '');
    btn.disabled = !!on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.textContent = on ? 'Sending...' : 'Send';
    if (st) st.textContent = on ? (text || '') : '';
  }

  function failText(err, fallbackMail) {
    if (err && err.name === 'AbortError') return 'That is taking too long. Please check your connection and press Send again. Your details are still here.';
    if (err && err.userMessage) return err.userMessage;
    return 'We could not reach our server. Please check your connection and press Send again. Your details are still here. If it keeps happening, email ' + fallbackMail + '.';
  }

  function post(url, init, ms) {
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, ms);
    if (ctl) init.signal = ctl.signal;
    return fetch(url, init).then(function (r) {
      clearTimeout(timer);
      return r.text().then(function (t) {
        var j = null;
        try { j = JSON.parse(t); } catch (e) { j = null; }
        if (r.ok && j && j.ok === true) return j;
        var err = new Error('relay ' + r.status);
        err.userMessage = j && typeof j.error === 'string' && j.error ? j.error : '';
        throw err;
      });
    }, function (e) { clearTimeout(timer); throw e; });
  }

  var testFail = (function () {
    if (ENV === 'live') return '';
    var v = new URLSearchParams(location.search).get('ch_test');
    return v === 'crm' || v === 'desk' || v === 'mail' ? v : '';
  })();

  function base(form, kind) {
    var o = {
      t: kind, fn: val(form, 'fn'), ln: val(form, 'ln'), em: val(form, 'em'), ph: val(form, 'ph'), co: val(form, 'co'),
      msg: val(form, 'msg'), env: ENV, trap: val(form, 'trap'), fill_ms: Date.now() - (openedAt[form.getAttribute('data-ch-form')] || Date.now()),
      pg: location.origin + location.pathname
    };
    if (testFail) o.test_fail = testFail;
    return o;
  }

  function notConfigured(form, url, mail) {
    if (urlOk(url)) return false;
    if (window.console) console.error('Contact hub: the ' + form.getAttribute('data-ch-form') + ' webhook URL setting is missing or not an https address.');
    formError(form, 'This form is not set up properly yet. Please email ' + mail + ' and we will help you.');
    return true;
  }

  function submitSales(form) {
    if (notConfigured(form, salesUrl, 'zonesales@zonemedical.com.au')) return;
    var data = base(form, 'sales');
    data.ct = val(form, 'ct');
    data.pr = val(form, 'pr');
    busy(form, true, 'Sending your enquiry...');
    post(salesUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) }, 70000)
      .then(function () {
        form.reset();
        busy(form, false);
        showThanks('Thanks, we have your enquiry.', 'Our sales team will get back to you soon.');
      })
      .catch(function (err) {
        busy(form, false);
        formError(form, failText(err, 'zonesales@zonemedical.com.au'));
      });
  }

  function submitSupport(form) {
    if (notConfigured(form, supportUrl, 'support@zonemedical.com.au')) return;
    var d = base(form, 'support');
    var fd = new FormData();
    d.stype = form.getAttribute('data-ch-form') === 'general' ? 'general' : val(form, 'stype');
    d.onum = val(form, 'onum');
    d.pcat = val(form, 'pcat');
    d.model = val(form, 'model');
    d.sn = val(form, 'sn');
    d.bought = val(form, 'bought');
    d.oprob = val(form, 'oprob');
    d.areq = val(form, 'areq');
    Object.keys(d).forEach(function (k) { fd.append(k, d[k]); });
    var input = form.querySelector('[data-ch-files]');
    if (d.stype !== 'accounts') [].slice.call((input && input.files) || []).forEach(function (f, i) { fd.append('attachment_' + (i + 1), f, f.name); });
    busy(form, true, 'Sending your request. Photos and videos can take a minute.');
    post(supportUrl, { method: 'POST', body: fd }, 90000)
      .then(function () {
        var accounts = d.stype === 'accounts';
        var general = d.stype === 'general';
        form.reset();
        fileCheck(form);
        [].forEach.call(form.querySelectorAll('[data-ch-group]'), function (g) { g.hidden = true; });
        busy(form, false);
        if (general) showThanks('Thanks, we have your message.', 'Our team will get back to you soon.');
        else showThanks('Thanks, we have your request.', accounts ? 'Our accounts team will get back to you soon.' : 'Our support team will get back to you soon.');
      })
      .catch(function (err) {
        busy(form, false);
        formError(form, failText(err, 'support@zonemedical.com.au'));
      });
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    [].forEach.call(hub.querySelectorAll('[data-ch-form]'), function (f) { busy(f, false); });
  });

  [].forEach.call(hub.querySelectorAll('[data-ch-form]'), function (form) {
    var kind = form.getAttribute('data-ch-form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.getAttribute('data-busy') === '1') return;
      formError(form, '');
      if (!validate(form, kind)) return;
      if (kind === 'sales') submitSales(form); else submitSupport(form);
    });
  });

  try { history.replaceState({ chPanel: null }, '', location.href); } catch (e) { /* ignore */ }
})();
